import { render, staticRenderFns } from "./TopImg2.vue?vue&type=template&id=ad2c7ea4"
import script from "./TopImg2.vue?vue&type=script&lang=js"
export * from "./TopImg2.vue?vue&type=script&lang=js"
import style0 from "./TopImg2.vue?vue&type=style&index=0&id=ad2c7ea4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports